module.exports = __webpack_public_path__ + "img/white-lens.6dba8337.svg";